import { render, staticRenderFns } from "./UserOnBoarding.vue?vue&type=template&id=72532e16&scoped=true&"
import script from "./UserOnBoarding.vue?vue&type=script&lang=js&"
export * from "./UserOnBoarding.vue?vue&type=script&lang=js&"
import style0 from "./UserOnBoarding.vue?vue&type=style&index=0&id=72532e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72532e16",
  null
  
)

export default component.exports